import { useCallback, useState } from 'react';
import { ConfirmationInput } from '@library/components/inputs';
import { ConfirmationModal } from '@library/components/modals/ConfirmationModal';
import { useExecuteResolutionMutation } from '@bo-services/resolutionsAPI';
import { useParams } from 'react-router-dom';

export interface ConfirmRefundModalProps {
  isRefundModalOpen: boolean;
  onClose: () => void;
}

export const ConfirmRefundModal = ({
  isRefundModalOpen,
  onClose
}: ConfirmRefundModalProps) => {
  const { resolutionId } = useParams();
  const [confirmationInputValue, setConfirmationInputValue] = useState('');

  const [executeResolution, { isError, isLoading, isUninitialized, reset }] =
    useExecuteResolutionMutation();
  const handleProcessRefund = useCallback(async () => {
    await executeResolution({ id: resolutionId || '' }).unwrap();
    onClose();
  }, [executeResolution, onClose, resolutionId]);

  const resetOnClose = useCallback(() => {
    setConfirmationInputValue('');
    if (!isUninitialized) {
      reset();
    }
  }, [isUninitialized, reset]);

  const handleModalClose = useCallback(() => {
    resetOnClose();
    onClose();
  }, [resetOnClose, onClose]);
  return (
    <ConfirmationModal
      confirmationCopy="Confirm"
      handleConfirm={handleProcessRefund}
      isLoading={isLoading}
      isOpen={isRefundModalOpen}
      label="Confirm Refund"
      onCancelModal={handleModalClose}
    >
      <p> Are you sure you want to process this refund? </p>
      <ConfirmationInput
        confirmationInputValue={confirmationInputValue}
        setConfirmationInputValue={setConfirmationInputValue}
      />
      {isError && (
        <div className="text-status-failure text-xs">
          An error occurred. Please try again.
        </div>
      )}
    </ConfirmationModal>
  );
};
